import { RfqListItemDTO } from '@luminovo/api-contracts';
import { isPresent } from '@luminovo/commons';

export const extractLowerVolumeEstimate = ({ ems_rfq_details }: RfqListItemDTO): number => {
    const vol = ems_rfq_details.volume_estimate;
    if (!vol || !isPresent(vol.lower)) {
        // Only the comparators use this: Infinity sorts a missing estimate last.
        return Infinity;
    }
    return parseFloat(vol.lower);
};
